import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AlertPopup from '../../../../CreateNewChild/AlertPopup';
import {
  BREAD_SCRUMB_CONSTANTS,
  IS_TESTED_FOR_HIV_OPTIONS,
  NewBornDetailsData,
  NewBornDetailsState,
  ServiceReportCodeForChild,
  STATUS_CONSTANTS,
  SYPHILIS_TEST_OPTIONS
} from './NewBornConstants';
import 'bootstrap/dist/css/bootstrap.min.css'
import CreateCommonComponent from '@components/common/CreateComponent';
import { getData, postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { toast } from 'react-toastify';
import CommonAddService from '@pages/Beneficiary-block/WomenComponent/FamilyPlanning/AddServices/CommonAddServices';
import { errorLogger } from '@utils/applicationLogUtils';
import { messages } from './NewBornConstants';
import {  areDatesSame, desiredFormatDate, formateDateToTimeStamp, getDifferenceInDays, getNotDoneOption, isServiceThroughSession, subtractDaysFromDate } from '@utils/commonUtils';
import {
  fetchBabyCriedOptions, fetchReferredToHigherManagementOptions, fetchChildAdmittedInOptions,
  fetchVisibleBirthDefectSeenOptions, fetchTreatedOrReferred, fetchBreastFeedingOptions, fetchMethodOfTreatment,
  fetchNevirapineSyrupOptions, fetchHIVPositive,
  fetchDiarrheaTreatment, fetchAEFIReported, fetchDeathRelatedInformationOptions, fetchDeathReasonOtherThanAEFI,
  fetchProbableCauseOfDeath, fetchPlaceOfDeath, fetchHbigVaccination, fetchOpv0, fetchBcg, fetchhepB0, fetchVitaminK,
  fetchSyphilsTest, fetchHavingPneumonia, fetchNacpReferralOptions
} from './NewBornInitialFetch'
import { isNewBornFormValidated, 
} from './FormValidator'
import useNavigateWithMenuItem from '@components/common/CustomHooks/useNavigateWithMenuItem';
import FormatDate from '@utils/dateFormat';
import { COMMON_CONSTANTS } from './NewBornConstants'
import { FIELD_CONSTANTS } from './NewBornConstants'
import { status_type } from '@constants/vhndExecutionConstant';
import dayjs from 'dayjs';
import { setBeneficiaryDetails, setBeneficiaryPregnancyHistory, setPregnancyDetails, updateAncService, updateChild } from '@store/actions/beneficiaryAction';
import '../NewBorn.css';
import { dateFormate } from '@constants/index';
import Spinner from '@components/common/Spinner';
interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  verifiedDetails?: any,
  isModalOpen?: boolean,
  code?: any
}
interface formStateType {
  [key: string]: objectType
}
interface formDataType {
  [key: string]: any;
}

const NewBornForm = () => {
  const navigateWithMenuItem = useNavigateWithMenuItem();
  const navigate = useNavigate();
  const [localFacilityDetails, setLocalFacilityDetails] = useState<any>({});
  const [formCompleted, setFormCompleted] = useState<boolean[]>([false]);
  const [progressBarPerc, setProgressBarPerc] = useState<number>(0);
  const [newBornDetailsFormState, setNewBornDetailsFormState] = useState<formStateType>(NewBornDetailsState);
  const [newBornDetailsFormData, setNewBornDetailsFormData] = useState<any>(NewBornDetailsData)
  const [closeModal, setCloseModal] = useState<boolean>(false);
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const benfDetails = useSelector((state: RootState) => state.beneficiary.childDetails,);
  const eventExecution = useSelector((state: RootState) => state.eventExution);
  const vhndExecutionId = eventExecution?.sessionDetailData?.vhnd_execution_id || null;
  const currentFacilityDetails = useSelector((state: RootState) => state.beneficiary.currentFacilityDetails);
  const vhndDetails = isServiceThroughSession(eventExecution);
  const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
  const isEditButtonClicked = useSelector((state: RootState) => state.beneficiary.isEditButtonClicked);
  const [backDatedFormDetails, setBackDatedFormDetails] = useState<formStateType>(NewBornDetailsState); 
  const [actionSource, setActionSource] = useState<string>(''); 
  const dateOfBirth = childDetails?.dob;
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        await initialFetch();
        if (childDetails?.benef_id) {
          await fetParentIllness(childDetails?.benef_id);
        }
      } finally {
        setLoader(false);
      }
    };
    fetchData();
    return () => {
      dispatch(updateChild('isEditButtonClicked', false));
    };
  }, [childDetails?.benef_id, dispatch])

  const initialFetch = async () => {
    fetchBabyCriedOptions(setNewBornDetailsFormData)
    fetchReferredToHigherManagementOptions(setNewBornDetailsFormData)
    fetchChildAdmittedInOptions(setNewBornDetailsFormData)
    fetchVisibleBirthDefectSeenOptions(setNewBornDetailsFormData)
    fetchTreatedOrReferred(setNewBornDetailsFormData)
    fetchMethodOfTreatment(setNewBornDetailsFormData)
    fetchBreastFeedingOptions(setNewBornDetailsFormData)
    fetchNevirapineSyrupOptions(setNewBornDetailsFormData)
    fetchHIVPositive(setNewBornDetailsFormData)
    fetchAEFIReported(setNewBornDetailsFormData)
    fetchHbigVaccination(setNewBornDetailsFormData),
      fetchOpv0(setNewBornDetailsFormData),
      fetchBcg(setNewBornDetailsFormData),
      fetchhepB0(setNewBornDetailsFormData),
      fetchVitaminK(setNewBornDetailsFormData),
      fetchSyphilsTest(setNewBornDetailsFormData),
      fetchNacpReferralOptions(setNewBornDetailsFormData)
    if (isEditButtonClicked) {
      try {
        const res = await getData<any>(`${endpoints.CompletedServiceList}/${childDetails?.benef_id}`)
        if (res && res.data && res.data.length > 0) {
          mapData(res);
        }
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    } else {
      //check if new born was already done for this child
      try {
        const res = await getData<any>(`${endpoints.CompletedServiceList}/${childDetails?.benef_id}`)
        if (res && res.data && res.data.length > 0) {
          // only pre-populate if selected visit date matches existing new born date
          const existingDate = res.data[0]?.visit_date;
          if (existingDate && dayjs(currentFacilityDetails?.visitDate).isSame(dayjs(existingDate), 'day')) {
            mapData(res);
          }
        }
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }
  let getParentIllness: any
  const fetParentIllness = async (benef_id?: string) => {
     if (!benef_id) {
      return;
    }
    try {
      getParentIllness = await getData<any[]>(`${endpoints.getParentIllness}/${benef_id}`);
      handleFieldValidation(getParentIllness);
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }

  const getHBIGMinDate = (dateOfBirth: string) => {
    return dateOfBirth ? dayjs().diff(dayjs(dateOfBirth), 'day') < 90 ? dayjs(dateOfBirth) : subtractDaysFromDate(dayjs(), 90, 'day') : subtractDaysFromDate(dayjs(), 90, 'day');
  }

  const handleFieldValidation = (illnessDetails: any) => {
    if (!illnessDetails?.data || !Array.isArray(illnessDetails.data)) return;
    let ishbsagReactive = false;
    let isreferredToConfirmFacility = false;

    illnessDetails.data.forEach((item: any) => {
      if (item?.service_code === COMMON_CONSTANTS.HIV_SCREENING && item?.service_report_code === COMMON_CONSTANTS.REFERRED_TO_CONFIRMATORY) {
        isreferredToConfirmFacility = true;
      } else if (item?.service_code === COMMON_CONSTANTS.HBSAG_TEST && item?.service_report_code === COMMON_CONSTANTS.REACTIVE) {
        ishbsagReactive = true;
      }
    });

    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        hbigVaccination: {
          ...prevState.hbigVaccination,
          '#required': ishbsagReactive,
          '#minDate': getHBIGMinDate(dateOfBirth),
          '#maxDate': dayjs(),
        },
        vitaminKGiven: {
           ...prevState.vitaminKGiven,
          '#required': false,
          '#minDate': dateOfBirth,
          '#maxDate': dateOfBirth,
        },
        isNevirapineSyrupStarted: {
          ...prevState.isNevirapineSyrupStarted,
          '#required': isreferredToConfirmFacility,
        },
        isTestedForHIV: {
          ...prevState.isTestedForHIV,
          '#required': isreferredToConfirmFacility,
        }
      };
    });
  }

      const mapData = (data: any) => {
          const initialState: any = {};
      
          Object.keys(JSON.parse(JSON.stringify(NewBornDetailsData))).forEach((key) => {
              initialState[key] = { value: null };
          });
        setLocalFacilityDetails({
          facilityId: data?.data[0]?.facility_id,
          healthProviderId: data?.data[0]?.healthprovider_id,
          mobiliserId: data?.data[0]?.mobiliser_id,
          visitDate: data?.data[0]?.visit_date,
        });
const updatedFormState = data?.data?.reduce((acc: any, item: any) => {
    const value = item.service_report;
    const serviceCode = item.service_code;
    const reportId = item.service_report_id;
    switch (serviceCode) {
        case ServiceReportCodeForChild.babyCriedImmediatelyAtBirth:
            acc.babyCried.value = value;
            acc.babyCried.reportId = reportId;
            break;
        case ServiceReportCodeForChild.referredForFurtherManagement:
            acc.referred.value = value;
            acc.referred.reportId = reportId;
            break;
        case ServiceReportCodeForChild.isChildAdmittedInNbsuSncuNicu:
            acc.isChildAdmitted.value = value;
            acc.isChildAdmitted.reportId = reportId;
            break;
        case ServiceReportCodeForChild.anyVisibleBirthDefectSeen:
            acc.birthDefectSeen.value = value;
            acc.birthDefectSeen.reportId = reportId;
            break;
        case ServiceReportCodeForChild.treatedOrReferred:
            acc.ifDefectIdentified.value = value;
            acc.ifDefectIdentified.reportId = reportId;
            break;
        case ServiceReportCodeForChild.methodOfTreatment:
            acc.methodOfTreatment.value = value;
            acc.methodOfTreatment.reportId = reportId;
            break;
        case ServiceReportCodeForChild.breastFeeding:
            acc.breastFeeding.value = value;
            acc.breastFeeding.reportId = reportId;
            break;
        case ServiceReportCodeForChild.hivPositive:
            acc.isTestedForHIV.value = value;
            acc.isTestedForHIV.reportId = reportId;
            break;
        case ServiceReportCodeForChild.isNevirapineSyrupStartedAtBirth:
            acc.isNevirapineSyrupStarted.value = value;
            acc.isNevirapineSyrupStarted.reportId = reportId;
            break;
        case ServiceReportCodeForChild.hbig:
            acc.hbigVaccination.value = item.service_date;
            acc.hbigVaccination.reportId = reportId;
            break;
        case ServiceReportCodeForChild.vitK:
            acc.vitaminKGiven.value = item.service_date;
            acc.vitaminKGiven.reportId = reportId;
            break;
        case ServiceReportCodeForChild.aefiReported:
            acc.whetherAefiReported.value = value;
            acc.whetherAefiReported.reportId = reportId;
            break;
        case ServiceReportCodeForChild.syphilisCurativeCareGiven:
            acc.syphilisTest.value = value;
            acc.syphilisTest.reportId = reportId;
            break;
      
        case ServiceReportCodeForChild.referredToNACP:
            acc.referredToNacpReferralFacility.value = value;
            acc.referredToNacpReferralFacility.reportId = reportId;
            break;
        default:
            break;
    }
    return acc;
}, initialState);


  const shouldEnableReferralOnLoad =
    updatedFormState?.isTestedForHIV?.value === IS_TESTED_FOR_HIV_OPTIONS.REFERRED_TO_CONFIRMATORY_FACILITY ||
    updatedFormState?.syphilisTest?.value === SYPHILIS_TEST_OPTIONS.REACTIVE;

  setNewBornDetailsFormData((prevDataState: any) => ({
   ...prevDataState,
   referred: {
    ...prevDataState.referred,
    '#isDisabled': updatedFormState?.babyCried?.value !== status_type.no.status_name
  },
  ifDefectIdentified: {
    ...prevDataState.ifDefectIdentified,
    '#isDisabled': updatedFormState?.birthDefectSeen?.value === STATUS_CONSTANTS.NO_DEFECT || !updatedFormState?.birthDefectSeen?.value
  },
  methodOfTreatment: {
    ...prevDataState.methodOfTreatment,
    '#isDisabled': (updatedFormState?.birthDefectSeen?.value === STATUS_CONSTANTS.NO_DEFECT || !updatedFormState?.birthDefectSeen?.value) || 
                   (updatedFormState?.ifDefectIdentified?.value !== STATUS_CONSTANTS.TREATED)
  },
  isNevirapineSyrupStarted: {
    ...prevDataState.isNevirapineSyrupStarted,
    '#isDisabled': !updatedFormState?.isTestedForHIV?.value || updatedFormState?.isTestedForHIV?.value === IS_TESTED_FOR_HIV_OPTIONS.NON_REACTIVE || updatedFormState?.isTestedForHIV?.value === IS_TESTED_FOR_HIV_OPTIONS.NOT_DONE
  },
  referredToNacpReferralFacility: {
    ...prevDataState.referredToNacpReferralFacility,
    '#isDisabled': !shouldEnableReferralOnLoad,
    '#required': shouldEnableReferralOnLoad,
  },
}));

      setNewBornDetailsFormState((prevState: any) => {
            const newState = {
              ...prevState,
              ['babyCried']: {
                ...prevState['babyCried'],
                value: updatedFormState?.babyCried?.value || null,
                id: updatedFormState?.babyCried?.reportId || null,
                isError: false,
                message: ''
              },
              ['referred']: {
                ...prevState['referred'],
                value: updatedFormState?.referred?.value || null,
                id: updatedFormState?.referred?.reportId || null,
                isError: false,
                message: ''
              },
              ['isChildAdmitted']: {
                ...prevState['isChildAdmitted'],
                value: updatedFormState?.isChildAdmitted?.value || null,
                id: updatedFormState?.isChildAdmitted?.reportId || null,
                isError: false,
                message: ''
              },
              ['birthDefectSeen']: {
                ...prevState['birthDefectSeen'],
                value: updatedFormState?.birthDefectSeen?.value || null,
                id: updatedFormState?.birthDefectSeen?.reportId || null,
                isError: false,
                message: ''
              },['ifDefectIdentified']: {
                ...prevState['ifDefectIdentified'],
                value: updatedFormState?.ifDefectIdentified?.value || null,
                id: updatedFormState?.ifDefectIdentified?.reportId || null,
                isError: false,
                message: ''
              },
              ['methodOfTreatment']: {
                ...prevState['methodOfTreatment'],
                value: updatedFormState?.methodOfTreatment?.value || null,
                id: updatedFormState?.methodOfTreatment?.reportId || null,
                isError: false,
                message: ''
              },
              ['breastFeeding']: {
                ...prevState['breastFeeding'],
                value: updatedFormState?.breastFeeding?.value || null,
                id: updatedFormState?.breastFeeding?.reportId || null,
                isError: false,
                message: ''
              },
              ['isTestedForHIV']: {
                ...prevState['isTestedForHIV'],
                value: getNotDoneOption(updatedFormState?.isTestedForHIV?.value),
                id: updatedFormState?.isTestedForHIV?.reportId || null,
                isError: false,
                message: ''
              },
              ['isNevirapineSyrupStarted']: {
                ...prevState['isNevirapineSyrupStarted'],
                value: updatedFormState?.isNevirapineSyrupStarted?.value || null,
                id: updatedFormState?.isNevirapineSyrupStarted?.reportId || null,
                isError: false,
                message: ''
              },
              ['hbigVaccination']: {
                ...prevState['hbigVaccination'],
                value: updatedFormState?.hbigVaccination?.value ? dayjs(updatedFormState.hbigVaccination.value) : null,
                id: updatedFormState?.hbigVaccination?.reportId || null,
                isError: false,
                message: ''
              },
               ['vitaminKGiven']: {
                ...prevState['vitaminKGiven'],
                value: updatedFormState?.vitaminKGiven?.value ? dayjs(updatedFormState.vitaminKGiven.value) : null,
                id: updatedFormState?.vitaminKGiven?.reportId || null,
                isError: false,
                message: ''
              },
              ['whetherAefiReported']: {
                ...prevState['whetherAefiReported'],
                value: updatedFormState?.whetherAefiReported?.value || null,
                id: updatedFormState?.whetherAefiReported?.reportId || null,
                isError: false,
                message: ''
              },
              ['syphilisTest']: {
                ...prevState['syphilisTest'],
                value: updatedFormState?.syphilisTest?.value || "Not Done",
                id: updatedFormState?.syphilisTest?.reportId || null,
                isError: false,
                message: ''
              },
              ['referredToNacpReferralFacility']: {
                ...prevState['referredToNacpReferralFacility'],
                value: updatedFormState?.referredToNacpReferralFacility?.value || null,
                id: updatedFormState?.referredToNacpReferralFacility?.reportId || null,
                isError: false,
                message: ''
              }
            };
            return newState;
          });

      // mirror pre-populated values so isFormChanged has correct baseline
      setBackDatedFormDetails((prev: any) => ({
        ...prev,
        babyCried: { ...prev.babyCried, value: updatedFormState?.babyCried?.value || null },
        referred: { ...prev.referred, value: updatedFormState?.referred?.value || null },
        isChildAdmitted: { ...prev.isChildAdmitted, value: updatedFormState?.isChildAdmitted?.value || null },
        birthDefectSeen: { ...prev.birthDefectSeen, value: updatedFormState?.birthDefectSeen?.value || null },
        ifDefectIdentified: { ...prev.ifDefectIdentified, value: updatedFormState?.ifDefectIdentified?.value || null },
        methodOfTreatment: { ...prev.methodOfTreatment, value: updatedFormState?.methodOfTreatment?.value || null },
        breastFeeding: { ...prev.breastFeeding, value: updatedFormState?.breastFeeding?.value || null },
        isTestedForHIV: { ...prev.isTestedForHIV, value: getNotDoneOption(updatedFormState?.isTestedForHIV?.value) },
        isNevirapineSyrupStarted: { ...prev.isNevirapineSyrupStarted, value: updatedFormState?.isNevirapineSyrupStarted?.value || null },
        hbigVaccination: { ...prev.hbigVaccination, value: updatedFormState?.hbigVaccination?.value ? dayjs(updatedFormState.hbigVaccination.value) : null },
        vitaminKGiven: { ...prev.vitaminKGiven, value: updatedFormState?.vitaminKGiven?.value ? dayjs(updatedFormState.vitaminKGiven.value) : null },
        whetherAefiReported: { ...prev.whetherAefiReported, value: updatedFormState?.whetherAefiReported?.value || null },
        syphilisTest: { ...prev.syphilisTest, value: updatedFormState?.syphilisTest?.value || 'Not Done' },
        referredToNacpReferralFacility: { ...prev.referredToNacpReferralFacility, value: updatedFormState?.referredToNacpReferralFacility?.value || null },
      }));
      };

  const handleNewBornDetailsFormChange = (value: any, key: string, id: any, dataOptions: any, code: any, changedData?: any, label?: any) => {
    setNewBornDetailsFormState((prevState: any) => {
      if (key === FIELD_CONSTANTS.BABY_CRIED) {
        setNewBornDetailsFormData((prevDataState: any) => {
          if (value === status_type.no.status_name) {
            return {
              ...prevDataState,
              referred: {
                ...prevDataState.referred,
                '#isDisabled': false,
              }
            };
          } else {
            return {
              ...prevDataState,
              referred: {
                ...prevDataState.referred,
                '#isDisabled': true,
              }
            };
          }
        });
        return {
          ...prevState,
          babyCried: {
            ...prevState.babyCried,
            value: value,
            isError: false,
            message: ''
          },
          referred: {
            ...prevState.referred,
            value: value === status_type.no.status_name ? prevState.referred.value : '',
            isError: false,
            message: ''
          }
        };
      }
      else if (key === FIELD_CONSTANTS.IS_REFERRED) {
      setNewBornDetailsFormData((prevDataState: any) => ({
        ...prevDataState,
        isChildAdmitted: {
          ...prevDataState.isChildAdmitted,
          '#isDisabled': false 
        }
      }));

      return {
        ...prevState,
        referred: {
          ...prevState.referred,
          value,
          isError: false,
          message: ''
        },
        isChildAdmitted: {
          ...prevState.isChildAdmitted,
          value: value === 'No referral' ? 'None': value, 
          isError: false,
          message: ''
        }
      };
    }

      else if (key === FIELD_CONSTANTS.IF_DEFECT_IDENTIFIED) {
        setNewBornDetailsFormData((prevDataState: any) => {
          if (value === STATUS_CONSTANTS.TREATED) {
            return {
              ...prevDataState,
              methodOfTreatment: {
                ...prevDataState.methodOfTreatment,
                '#isDisabled': false,
              }
            };
          } else {
            return {
              ...prevDataState,
              methodOfTreatment: {
                ...prevDataState.methodOfTreatment,
                '#isDisabled': true,
              }
            };
          }
        });
        return {
          ...prevState,
          ifDefectIdentified: {
            ...prevState.ifDefectIdentified,
            value: value,
            isError: false,
            message: ''
          },
          methodOfTreatment: {
            ...prevState.methodOfTreatment,
            value: value === STATUS_CONSTANTS.TREATED ? prevState.methodOfTreatment.value : '',
            isError: false,
            message: ''
          }
        };
      }

      else if (key === FIELD_CONSTANTS.BIRTH_DEFECT_SEEN) {
        setNewBornDetailsFormData((prevDataState: any) => {
          if (value !== STATUS_CONSTANTS.NO_DEFECT && value) {
            return {
              ...prevDataState,
              ifDefectIdentified: {
                ...prevDataState.ifDefectIdentified,
                '#isDisabled': false,
              }
            };
          } else {
            return {
              ...prevDataState,
              ifDefectIdentified: {
                ...prevDataState.ifDefectIdentified,
                '#isDisabled': true,
              },
              methodOfTreatment: {
                ...prevDataState.methodOfTreatment,
                '#isDisabled': true,
              }
            };
          }
        });

        return {
          ...prevState,
          birthDefectSeen: {
            ...prevState.birthDefectSeen,
            value: value,
            isError: false,
            message: ''
          },
          ifDefectIdentified: {
            ...prevState.ifDefectIdentified,
            value: value !== STATUS_CONSTANTS.NO_DEFECT && value ? prevState.ifDefectIdentified.value : '',
            isError: false,
            message: ''
          },
          methodOfTreatment: {
            ...prevState.methodOfTreatment,
            value: value !== STATUS_CONSTANTS.NO_DEFECT && value ? prevState.methodOfTreatment.value : '',
            isError: false,
            message: ''
          }
        };
      }

      else if (key === FIELD_CONSTANTS.SYPHILIS_TEST || key === FIELD_CONSTANTS.IS_TESTED_FOR_HIV) {
        const syphilisValue = key === FIELD_CONSTANTS.SYPHILIS_TEST ? value : prevState.syphilisTest.value;
        const hivValue = key === FIELD_CONSTANTS.IS_TESTED_FOR_HIV ? value : prevState.isTestedForHIV.value;
      
        const shouldEnableReferral =
          hivValue === IS_TESTED_FOR_HIV_OPTIONS.REFERRED_TO_CONFIRMATORY_FACILITY ||
          syphilisValue === SYPHILIS_TEST_OPTIONS.REACTIVE;

        const shouldDisableNevirapine = hivValue === IS_TESTED_FOR_HIV_OPTIONS.NON_REACTIVE || hivValue === IS_TESTED_FOR_HIV_OPTIONS.NOT_DONE || !hivValue;
      
        setNewBornDetailsFormData((prevDataState: any) => ({
          ...prevDataState,
          referredToNacpReferralFacility: {
            ...prevDataState.referredToNacpReferralFacility,
            '#isDisabled': !shouldEnableReferral,
            '#required': shouldEnableReferral,
          },
          isNevirapineSyrupStarted: {
            ...prevDataState.isNevirapineSyrupStarted,
            '#isDisabled': shouldDisableNevirapine,
          }
        }));
      
        return {
          ...prevState,
          [key]: {
            ...prevState[key],
            value: value,
            isError: false,
            message: ''
          },
          referredToNacpReferralFacility: {
            ...prevState.referredToNacpReferralFacility,
            value: shouldEnableReferral ? prevState.referredToNacpReferralFacility.value : '',
            isError: false,
            message: ''
          },
          isNevirapineSyrupStarted: {
            ...prevState.isNevirapineSyrupStarted,
            value: shouldDisableNevirapine ? '' : prevState.isNevirapineSyrupStarted.value,
            isError: false,
            message: ''
          }
        };
      }


      return {
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          isError: false,
          message: ''
        },
      }
    })

  }



  const formContent = (
    <div className='new-born-form'>
      {loader? <Spinner />:
      <CommonAddService handleFormChange={handleNewBornDetailsFormChange} formState={newBornDetailsFormState} formData={newBornDetailsFormData} />
      }</div>
  );

  const handleSave = () => {
    setLoader(true);
    const validationErrors: boolean[] = [false];
    
    isNewBornFormValidated(newBornDetailsFormState, setNewBornDetailsFormState, validationErrors, 0, dateOfBirth, getParentIllness, newBornDetailsFormData);
    
    if (!validationErrors[0]) {
      setFormCompleted([true]);
      setProgressBarPerc(100);
    } else {

      setFormCompleted([false]);
      setProgressBarPerc(0);
    }
    setLoader(false);
  }

  const finishHandler = async () => {

    try {
      setLoader(true);
      const userId = localStorage.getItem('userId');
      const payload = {
        p_benef_id: benfDetails?.benef_id,
        p_vhnd_execution_id: vhndExecutionId,
        p_session_id: vhndDetails?.sessionId || null,
        p_facility_id: isEditButtonClicked ? localFacilityDetails.facilityId : currentFacilityDetails.facilityId,
        p_healthprovider_id: isEditButtonClicked ? localFacilityDetails.healthProviderId : currentFacilityDetails.healthProviderId,
        p_mobiliser_id: isEditButtonClicked ? localFacilityDetails.mobiliserId : currentFacilityDetails.mobilizerId,
        p_visit_date: isEditButtonClicked ? FormatDate(localFacilityDetails.visitDate) : FormatDate(currentFacilityDetails.visitDate),
        p_baby_cried_immediately_at_birth_service_id: getServiceIdByValue(newBornDetailsFormData.babyCried['#options'], newBornDetailsFormState.babyCried.value),
        p_baby_cried_immediately_at_birth_report_id: getReportIdByValue(newBornDetailsFormData.babyCried['#options'], newBornDetailsFormState.babyCried.value),
        p_referred_to_higher_facility_for_further_management_service_id: getServiceIdByValue(newBornDetailsFormData.referred['#options'], newBornDetailsFormState.referred.value),
        p_referred_to_higher_facility_for_further_management_report_id: getReportIdByValue(newBornDetailsFormData.referred['#options'], newBornDetailsFormState.referred.value),
        p_is_child_admitted_in_service_id: getServiceIdByValue(newBornDetailsFormData.isChildAdmitted['#options'], newBornDetailsFormState.isChildAdmitted.value),
        p_is_child_admitted_in_report_id: getReportIdByValue(newBornDetailsFormData.isChildAdmitted['#options'], newBornDetailsFormState.isChildAdmitted.value),
        p_any_visible_birth_defect_seen_service_id: getServiceIdByValue(newBornDetailsFormData.birthDefectSeen['#options'], newBornDetailsFormState.birthDefectSeen.value),
        p_any_visible_birth_defect_seen_report_id: getReportIdByValue(newBornDetailsFormData.birthDefectSeen['#options'], newBornDetailsFormState.birthDefectSeen.value),
        p_if_any_defect_referred_to_higher_facility_service_id: getServiceIdByValue(newBornDetailsFormData.ifDefectIdentified['#options'], newBornDetailsFormState.ifDefectIdentified.value),
        p_if_any_defect_referred_to_higher_facility_report_id: getReportIdByValue(newBornDetailsFormData.ifDefectIdentified['#options'], newBornDetailsFormState.ifDefectIdentified.value),
        p_if_treatment_done_method_of_treatment_service_id: getServiceIdByValue(newBornDetailsFormData.methodOfTreatment['#options'], newBornDetailsFormState.methodOfTreatment.value),
        p_if_treatment_done_method_of_treatment_report_id: getReportIdByValue(newBornDetailsFormData.methodOfTreatment['#options'], newBornDetailsFormState.methodOfTreatment.value),
        p_breast_feeding_started_within_one_hour_of_delivery_service_id: getServiceIdByValue(newBornDetailsFormData.breastFeeding['#options'], newBornDetailsFormState.breastFeeding.value),
        p_breast_feeding_started_within_one_hour_of_delivery_report_id: getReportIdByValue(newBornDetailsFormData.breastFeeding['#options'], newBornDetailsFormState.breastFeeding.value),
        p_hiv_screening_test_service_id: getServiceIdByValue(newBornDetailsFormData.isTestedForHIV['#options'], newBornDetailsFormState.isTestedForHIV.value),
        p_hiv_screening_test_report_id: getReportIdByValue(newBornDetailsFormData.isTestedForHIV['#options'], newBornDetailsFormState.isTestedForHIV.value),
        p_is_nevirapine_syrup_started_at_birth_service_id: getServiceIdByValue(newBornDetailsFormData.isNevirapineSyrupStarted['#options'], newBornDetailsFormState.isNevirapineSyrupStarted.value),
        p_is_nevirapine_syrup_started_at_birth_report_id: getReportIdByValue(newBornDetailsFormData.isNevirapineSyrupStarted['#options'], newBornDetailsFormState.isNevirapineSyrupStarted.value),
        p_aefi_reported_if_any_service_id: getServiceIdByValue(newBornDetailsFormData.whetherAefiReported['#options'], newBornDetailsFormState.whetherAefiReported.value),
        p_aefi_reported_if_any_report_id: getReportIdByValue(newBornDetailsFormData.whetherAefiReported['#options'], newBornDetailsFormState.whetherAefiReported.value),
        p_diarrhea_treatment_if_any_service_id: null,
        p_diarrhea_treatment_if_any_report_id: null,
        p_is_the_child_having_pneumonia_service_id: null,
        p_is_the_child_having_pneumonia_report_id: null,
        p_hbig_service_id: newBornDetailsFormData?.hbigVaccination?.['#serviceId'],
        p_hbig_sevice_date: newBornDetailsFormState?.hbigVaccination?.value ? FormatDate(newBornDetailsFormState.hbigVaccination.value) : null,
        p_opv0_service_id: null,  
        p_opv0_sevice_date: null,
        p_bcg_service_id: null,
        p_bcg_sevice_date: null,
        p_hepb0_service_id: null,
        p_hepb0_sevice_date: null,
        p_vitk_service_id: newBornDetailsFormData?.vitaminKGiven?.['#serviceId'],
        p_vitk_sevice_date: newBornDetailsFormState?.vitaminKGiven?.value ? FormatDate(newBornDetailsFormState.vitaminKGiven.value) : null,
        p_referred_to_nacp_referral_facility_service_id: getServiceIdByValue(newBornDetailsFormData.referredToNacpReferralFacility['#options'], newBornDetailsFormState.referredToNacpReferralFacility.value),
        p_referred_to_nacp_referral_facility_report_id: getReportIdByValue(newBornDetailsFormData.referredToNacpReferralFacility['#options'], newBornDetailsFormState.referredToNacpReferralFacility.value),
        p_syphilis_test_service_id: getServiceIdByValue(newBornDetailsFormData.syphilisTest['#options'], newBornDetailsFormState.syphilisTest.value),
        p_syphilis_test_report_id: getReportIdByValue(newBornDetailsFormData.syphilisTest['#options'], newBornDetailsFormState.syphilisTest.value),
        p_parent_user_id: userId,
        p_is_death_happend: null,
        p_probable_cause_of_death_id: null,
        p_date_of_death: null,  
        p_place_of_death_id: null,
        p_notification_sent_by_asha_with_24hrs: null,
        p_fbir_completed_by_anm: null,
        p_death_reason_id: null
      }
      const response = await postDataJSON<any>(`${endpoints.ChildServiceReport}`, payload);
      toast.success(isEditButtonClicked ? messages.newBornEditSuccessMessage:messages.newBornSuccessMessage , {
        position: 'top-center',
      });
      dispatch(updateAncService('currentFacilityDetails', {}));
      // dispatch(updateChild('isNewBornSameDay', false));
      navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
    }
    catch (error: any) {
      toast.error(error?.message, {
        position: 'top-center',
      });
    }
    finally {
      setLoader(false);
    }

  }

 ;


  const closeCreateModal = (value: boolean) => {
    if (value) {
      navigate(`/beneficiaries/view/${benfDetails?.benef_id}`);
      dispatch(setBeneficiaryDetails([]));
      dispatch(setBeneficiaryPregnancyHistory({}));
      dispatch(setPregnancyDetails({}));
    } else {
      setCloseModal(false);
    }
  }

  const getServiceIdByValue = (options: any[], value: string) => {
    try {
      const foundOption = options.find(option => option.value === value);
      return foundOption ? foundOption.serviceId : null;
    }
    catch (error: any) {
      errorLogger(error)
    }
  };

  const getReportIdByValue = (options: any[], value: string) => {
    try {
      const foundOption = options.find(option => option.value === value);
      return foundOption ? foundOption.reportId : null;
    }
    catch (error: any) {
      errorLogger(error)
    }
  };
  const serviceDetails = {
    currRoute: currentFacilityDetails?.currRoute,
  };

  const breadcrumbItemName = [
    { value: 0, label: BREAD_SCRUMB_CONSTANTS.SERVICE_PROVIDER },
    { value: 0, label: BREAD_SCRUMB_CONSTANTS.BENEFICIARY_PROFILE },
  ]

  const isFormChanged = (formState: formStateType) => {
    const wasPrePopulated = isEditButtonClicked || Object.keys(localFacilityDetails).length > 0;
    const baseObject: Record<string, any> = wasPrePopulated 
      ? backDatedFormDetails 
      : (NewBornDetailsState as Record<string, any>);
    for (const key in NewBornDetailsState) {
      if (formState[key]?.value !== baseObject[key]?.value) {
        return true;
      }
    }
    return false;
  };

  return (
    <div>
      <CreateCommonComponent
        breadcrumbItemName={breadcrumbItemName}
        onHandleBackArrowButton={() => {
          if (isFormChanged(newBornDetailsFormState)) {
            setActionSource('back');
            setAlertModalOpen(true);
          } else if (isEditButtonClicked) {
            navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
          } else {
            navigateWithMenuItem('/beneficiaries/child/service-facility-details', 'Services', serviceDetails);
          }
        }}
        navItemsModal={[COMMON_CONSTANTS.NEW_BORN_DETAILS]}
        activeIndex={0}
        handleNavClick={() => {}}
        formCompleted={formCompleted}
        headerName={COMMON_CONSTANTS.HEADER_NAME}
        progressBarPerc={progressBarPerc}
        contents={[formContent]}
        handlePrevious={() => {}}
        handleSubmit={handleSave}
        finishHandler={finishHandler}
        handleNext={() => {}}
        handleCancel={() => setCloseModal(true)}
        closeCreateModal={closeCreateModal}
        closeModal={closeModal}/>
      <AlertPopup
        showModal={alertModalOpen}
        closeModal={(value: boolean) => {
          if (value) {
            setAlertModalOpen(false);
            if (actionSource === 'back') {
              if (isEditButtonClicked) {
                navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
              } else {
                navigateWithMenuItem('/beneficiaries/child/service-facility-details', 'Services', serviceDetails);
              }
            } else {
              // cancel action — always go to view
              navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
            }
          } else {
            setAlertModalOpen(false);
          }
        }}
        title={COMMON_CONSTANTS.MODAL_TITLE}
      />
    </div>
  );
};

export default NewBornForm;
